import React from 'react';

const DeckSize = ({ onChange }) => {
  return (
    <div className="field_wrapper">
      <h3>Deck Size</h3>
      <div className="field">
        <label htmlFor="deck_sqft">Deck Square Footage</label>
        <input type="number" name="deck_sqft" min="0" onChange={(e) => onChange(e.target.value, 'sqft')} />
      </div>
      <span className="field_or">OR</span>
      <div className="field">
        <label htmlFor="deck_sqft" style={{ display: 'block'}}>Deck Dimensions</label>
        <span className="deck_dimensions_fields">
          <div className="deck_dimension_field">
          <label>Length (ft):</label>
            <input type="number" name="deck_length" min="0" onChange={(e) => onChange(e.target.value, 'length')} />
            </div>
          <div className="deck_dimension_field">
            <label>Width (ft):</label>
            <input type="number" name="deck_width" min="0" onChange={(e) => onChange(e.target.value, 'width')} />
          </div>
        </span>
      </div>
    </div>
  );
};

export default DeckSize;